module.exports = __webpack_public_path__ + "img/cubingtrainer.2a643ff3.png";